var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06189 9.33333C9.25314 9.33311 9.44283 9.36997 9.6217 9.44212L8.23107 3.05592C8.22312 3.01943 8.221 2.98178 8.22482 2.94454L8.30362 2.17167C8.3726 1.5081 8.15368 0.847251 7.70909 0.377C7.48299 0.135675 7.1761 0.000178699 6.85615 0.000416667C6.85126 0.000416667 6.84638 0.00025 6.84153 0H1.82355C3.8713 0.237037 3.29558 3.33333 3.29558 3.33333L3.87843 6L4.38665 8.33333L4.60429 9.33333H9.06189ZM1.21388 2.76915e-06H1.20043C0.838617 0.00229951 0.496879 0.17759 0.269432 0.477544C0.0401201 0.77763 -0.0492954 1.17231 0.0262651 1.55088L1.83295 10.6765C1.9892 11.4472 2.62775 11.9979 3.36743 12H9.06189C9.57999 12 10 11.5523 10 11C10 10.4477 9.57999 10 9.06189 10H4.35569C4.21016 10.0001 4.08381 9.89312 4.05092 9.742L3.74436 8.33334L3.23621 6L2.59712 3.07563C2.5956 3.06871 2.59431 3.06179 2.59321 3.05479L2.59009 3.03479C2.5854 3.00487 2.58457 2.97441 2.58762 2.94425L2.6658 2.1705C2.73435 1.50747 2.51575 0.847262 2.07194 0.377003C1.84403 0.135185 1.53544 -0.000395987 1.21388 2.76915e-06Z",
    fill: "#C2C6D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/Class.e7fb00421a75fb264e4fca04a4177547.svg";
export { ForwardRef as ReactComponent };